import { html, TemplateResult, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import globalStyles from './styles/outline-chip-list.global.pcss?inline';
import encapsulatedStyles from './styles/outline-chip-list.encapsulated.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import '../outline-link/outline-link';
/**
 * The element name, reused throughout the codebase
 * @type {string}
 */
const componentName = 'outline-chip-list';

/**
 * The Outline Chip List component
 *
 * A reusable LitElement component for displaying chip-lists.
 *
 * @element outline-chip-list
 * @extends LitElement
 */
@customElement(componentName)
export class OutlineChipList extends LitElement {
  /**
   * Adopted stylesheets for the component
   *
   * @type {AdoptedStyleSheets}
   */
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });
  
  render(): TemplateResult {
    return html`
      <section class="outline-chip-list">
        <div class="outline-chip-list--wrapper">
          <slot></slot>
        </div>
      </section>
    `;
  }
}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineChipList;
  }
}
